/*
 * Project: forca
 * File Created: Wednesday, 12th January 2022 12:51:29 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

export const INTERVAL = 7000; // 7 sec